import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import GlobalContext from "../../context/GlobalContext";
import { tr } from "../../i18n";
import "./OnBoarding.css";

const OnBoarding = () => {
  const navigate = useNavigate();
  const { logoutApiCall } = useContext(GlobalContext);

  useEffect(() => {
    const container = document.getElementById("onboarding-stars");
    if (!container) return;
    for (let i = 0; i < 24; i++) {
      const star = document.createElement("div");
      star.className = "star";
      const size = Math.random() * 3 + 1.5;
      star.style.cssText = `left:${Math.random() * 100}%;top:${Math.random() * 100}%;width:${size}px;height:${size}px;animation-delay:${(Math.random() * 3).toFixed(2)}s`;
      container.appendChild(star);
    }
  }, []);

  const openExternalUrl = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const requestOpenSewoorkMobile = () => {
    const shouldOpen = window.confirm(
      tr("register:open_sewoork_mobile_app_on_this"),
    );

    if (shouldOpen) {
      window.location.href = "sewoork://open";
    }
  };

  const isPhoneDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <>
      <Helmet>
        <title>{tr("register:console_access")}</title>
      </Helmet>

      <section className="onboarding-wrap">
        <div className="onboarding-card">
          <div className="rocket-scene">
            <div className="stars" id="onboarding-stars" />
            <div className="rocket-wrapper">
              <div className="rocket-body">
                <div className="rocket-nose" />
                <div className="rocket-fuselage">
                  <div className="rocket-window" />
                </div>
                <div className="rocket-fins">
                  <div className="fin fin-left" />
                  <div className="fin fin-right" />
                </div>
              </div>
              <div className="rocket-exhaust">
                <div className="flame flame-1" />
                <div className="flame flame-2" />
                <div className="flame flame-3" />
              </div>
              <div className="launch-pad" />
            </div>
          </div>

          <div className="onboarding-content">
            <h1 className="onboarding-title">
              {tr("register:looks_like_you_don_t_have")}
            </h1>
            <p className="onboarding-subtitle">
              {tr("register:get_started_by_creating_your_first")}
            </p>
            <div className="onboarding-actions">
              <button
                className="btn-primary"
                onClick={() => navigate("/get-started?plan=free")}
              >
                {tr("register:create_your_organization")}
              </button>

              <div className="store-actions">
                <button
                  className="store-badge store-badge-play"
                  onClick={() =>
                    openExternalUrl(
                      "https://play.google.com/store/apps/details?id=com.sewoork.app",
                    )
                  }
                >
                  <div className="store-icon">
                    <svg viewBox="30 336.7 120.9 129.2" width="25">
                    <path fill="#FFD400" d="M119.2,421.2c15.3-8.4,27-14.8,28-15.3c3.2-1.7,6.5-6.2,0-9.7  c-2.1-1.1-13.4-7.3-28-15.3l-20.1,20.2L119.2,421.2z">
                    </path>
                    <path fill="#FF3333" d="M99.1,401.1l-64.2,64.7c1.5,0.2,3.2-0.2,5.2-1.3  c4.2-2.3,48.8-26.7,79.1-43.3L99.1,401.1L99.1,401.1z">
                    </path>
                    <path fill="#48FF48" d="M99.1,401.1l20.1-20.2c0,0-74.6-40.7-79.1-43.1  c-1.7-1-3.6-1.3-5.3-1L99.1,401.1z">
                    </path>
                    <path fill="#3BCCFF" d="M99.1,401.1l-64.3-64.3c-2.6,0.6-4.8,2.9-4.8,7.6  c0,7.5,0,107.5,0,113.8c0,4.3,1.7,7.4,4.9,7.7L99.1,401.1z">
                    </path>
                </svg>
                  </div>
                  <span className="store-copy">
                    <span className="store-copy-top">{tr("register:get_it_on")}</span>
                    <span className="store-copy-bottom">{tr("register:google_play")}</span>
                  </span>
                </button>
                <button
                  className="store-badge store-badge-appstore"
                  onClick={() => openExternalUrl("https://apps.apple.com/app/sewoork/id6779068695")}
                >
                  <span className="store-icon apple-icon" aria-hidden="true">
                    <svg viewBox="0 0 384 512" width="25">
                      <path
                        fill="currentColor"
                        d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                      ></path>
                    </svg>
                  </span>
                  <span className="store-copy">
                    <span className="store-copy-top">{tr("register:download_on_the")}</span>
                    <span className="store-copy-bottom">{tr("register:app_store")}</span>
                  </span>
                </button>
              </div>

              {isPhoneDevice && (
                <button
                  className="btn-open-mobile"
                  onClick={requestOpenSewoorkMobile}
                >
                  {tr("register:open_sewoork_mobile_on_this_phone")}
                </button>
              )}

              <button className="btn-ghost" onClick={logoutApiCall}>
                {tr("common:profile.sign_out")}
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OnBoarding;
